import React, { useState } from "react"
import {
  Box,
  Button,
  Typography,
} from "@mui/material"

import EXTRA_ORDER_DETAILS from "../../supplier/tools/auxiliar_table/extra_order_details";
import EXTRA_INVOICE_DETAILS from "../../supplier/tools/auxiliar_table/extra_invoice_details";
import SUBTOTAL_MISMATCH_DETAILS from "../../supplier/tools/auxiliar_table/subtotal_mismatch_details";
interface CustomTableProps {
  data: any;
}


const SUPPLIER_ERROR_DETAIL: React.FC<CustomTableProps> = ({ data }) => {
  const [activeTab, setActiveTab] = useState(0);
  
  if (data?.status_code == 1) {
    return (
      <Box sx={{ bgcolor: "#f5f5f5", p: 2 }}>
        <h4>No hay factura relacionada.</h4>
      </Box>
    );
  }

  return (
    <div>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap={1}
        p={2}
        mb={4}
        bgcolor="#EEF4FF"
        borderRadius="8px"
      >
        {/* Sección izquierda: ícono + texto */}
        <Box display="flex" alignItems="center" gap={1}>
          {/* <InfoOutlinedIcon color="primary" /> */}
          {data?.error_details.error_detail_counter === 0 ?
            <Typography fontSize="14px" color="#344054">
              No hay diferencias
            </Typography>
            :
            <Typography fontSize="14px" color="#344054">
              SE ENCONTRARON <strong>{data?.error_details.error_detail_counter===undefined? 0 :data?.error_details.error_detail_counter}</strong> DIFERENCIAS ENTRE LA ORDEN DE COMPRA Y LA FACTURA.
            </Typography>
          }
        </Box>
      </Box>



      <Box
        display="start-flex"
        border="1px solid #D0D5DD"
        borderRadius="10px"
        p="3px"
        bgcolor="#F9FAFB"
        mt={2}
        mx={2}
      >
        {data?.error_details?.extra_order_details?.length > 0 && (
          <Button
            onClick={() => setActiveTab(0)}
            sx={{
              borderRadius: "8px",
              px: 2,
              py: 1,
              minWidth: "150px",
              backgroundColor: activeTab === 0 ? "#173B8C" : "transparent",
              color: activeTab === 0 ? "#fff" : "#667085",
              fontWeight: activeTab === 0 ? "bold" : "normal",
              boxShadow: activeTab === 0 ? "0px 1px 2px rgba(16, 24, 40, 0.05)" : "none",
              "&:hover": {
                backgroundColor: activeTab === 0 ? "#102b6e" : "#F0F2F5"
              },
              textTransform: "none",
              fontSize: "14px"
            }}
          >
            CONCEPTOS NO ENCONTRADOS EN LA FACTURA
          </Button>
        )}

        {data?.error_details?.extra_invoice_details?.length > 0 && (

          <Button
            onClick={() => setActiveTab(1)}
            sx={{
              borderRadius: "8px",
              px: 2,
              py: 1,
              minWidth: "150px",
              backgroundColor: activeTab === 1 ? "#173B8C" : "transparent",
              color: activeTab === 1 ? "#fff" : "#667085",
              fontWeight: activeTab === 1 ? "bold" : "normal",
              boxShadow: activeTab === 1 ? "0px 1px 2px rgba(16, 24, 40, 0.05)" : "none",
              "&:hover": {
                backgroundColor: activeTab === 1 ? "#102b6e" : "#F0F2F5"
              },
              textTransform: "none",
              fontSize: "14px"
            }}
          >
            CONCEPTOS EXTRA EN LA FACTURA
          </Button>
        )}

        {data?.error_details?.subtotal_mismatch_details?.length > 0 && (
          <Button
            onClick={() => setActiveTab(2)}
            sx={{
              borderRadius: "8px",
              px: 2,
              py: 1,
              minWidth: "120px",
              backgroundColor: activeTab === 2 ? "#173B8C" : "transparent",
              color: activeTab === 2 ? "#fff" : "#667085",
              fontWeight: activeTab === 2 ? "bold" : "normal",
              boxShadow: activeTab === 2 ? "0px 1px 2px rgba(16, 24, 40, 0.05)" : "none",
              "&:hover": {
                backgroundColor: activeTab === 2 ? "#102b6e" : "#F0F2F5"
              },
              textTransform: "none",
              fontSize: "14px"
            }}
          >
            DIFERENCIAS EN PRECIOS
          </Button>
        )}

      </Box>

      <Box px={2} mt={2}>
        {activeTab === 0 && data?.error_details.extra_order_details?.length > 0 && (
          <EXTRA_ORDER_DETAILS detaills={data?.error_details.extra_order_details} />
        )}

        {activeTab === 1 && data?.error_details.extra_invoice_details?.length > 0 && (
          <EXTRA_INVOICE_DETAILS detaills={data?.error_details.extra_invoice_details} />
        )}

        {activeTab === 2 && data?.error_details.subtotal_mismatch_details?.length > 0 && (
          <SUBTOTAL_MISMATCH_DETAILS detaills={data?.error_details.subtotal_mismatch_details} />
        )}
      </Box>

    </div>
  );
}


export default SUPPLIER_ERROR_DETAIL;